
























































































require("axios");
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import NewApi, { BasePath , ImagePath, ImageThumbPath } from "../ts/api";
import { DefaultApi, Image, Galleries, Gallery } from "../api";
import draggable from "vuedraggable";

import Modal from './Modal.vue'

let api: DefaultApi;

@Component({
  components: {
    draggable,
    Modal,
  }
})
export default class HelloWorld extends Vue {
  galleries = [] as Galleries[];
  newGallery = {} as Gallery;
  selectedGallery = {} as Gallery;
  imgPool = [] as Image[];
  isDragging = false;
showModal = false
  @Watch("imgPool") onGalleryChanged(value: Gallery, oldValue: Gallery) {
    this.updateGallery();
  }

selectCover(i :Image){
  this.selectedGallery.cover = i
  this.updateGallery()
}

  updateGallery() {
    for (let i = 0; i < this.selectedGallery.images.length; i++) {
      this.selectedGallery.images[i].order = i;
    }
    console.log("from watch");

    if(this.selectedGallery.cover != null && this.selectedGallery.cover.id == 0){
      this.selectedGallery.cover = this.selectedGallery.images[0]
    }

    api
      .galleryPut(this.selectedGallery)
      .then(r => console.log("gallery updated"))
      .catch(e => console.error("could not update gallery"));
  }

  mounted() {
    api = NewApi();
    this.getGalleries();
    this.getImages();
  }

  get dragOptions() {
    return {
      animation: 0,
      group: "description",
      ghostClass: "ghost"
    };
  }

  getGalleries() {
    var resp = api.galleryGet();
    let ctx = this
    resp
      .then(function(r){
        ctx.galleries = r.data
        })
      .catch(e => console.error("failed to fetch galleries"));
  }

  getGallery(g: Galleries) {
    var resp = api
      .galleryIdGet(g.id)
      .then(g => (this.selectedGallery = g.data))
      .catch(e => console.error("failed to fetch gallery"));
  }

  createGallery() {
    let ctx = this
    if (this.newGallery) {
      var resp = api.galleryPost(this.newGallery);
      resp
        .then(function(r){
          ctx.getGalleries()
          ctx.newGallery = {} as Gallery
        })
        .catch(e => console.error("failed to create gallery"));
    }
  }

  deleteGallery(g : Gallery){
    let ctx = this
    api.galleryDelete(g.id).then(function(r){
ctx.selectedGallery = {} as Gallery
ctx.getGalleries()
    }).catch(e => console.error("could not delete gallery: " + e))
  }

  getImageUrl(filename: string) {
    return ImageThumbPath(filename)
  }

  getImages() {
    this.imgPool = [];
    let ctx = this;
    var resp = api.imageGet();
    resp
      .then(function(i) {
        for (let img in i.data) {
          if (i.data[img].gallery_id == 0) {
            ctx.imgPool.push(i.data[img]);
          }
        }

        ctx.imgPool.sort(function(a, b) {
          return a.order - b.order;
        });
      })
      .catch(e => console.log("fail to fetch images"));
  }

}
